import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import ManagePayout from '../../../components/siteadmin/ManagePayout/ManagePayout';

import reservationsQuery from './reservationsQuery.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import s from "./PayoutManagement.css";
class PayoutManagement extends React.Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        data: PropTypes.shape({
            loading: PropTypes.bool,
            getAllPayoutReservation: PropTypes.array,
        })
    }

    render() {
        const {  getAllPayouts, title } = this.props;
        return <ManagePayout
            getAllPayouts={getAllPayouts}
            title={title}
        />
    }
}

export default compose(
    withStyles(s),
    withQuery(reservationsQuery, {
        name: 'getAllPayouts',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only',
            ssr: false
        }
    })
)(PayoutManagement);